import { PhoneType } from "./PhoneType";
import { Tenant } from "./Tenant";
import { User } from "./User";
import { Violation } from "./Violations";

export interface LoginResponseData {
  user: User;
  userTenants: Array<Tenant>;
  phoneTypes: Array<PhoneType>;
  standardViolations: Array<Violation>;
  colors: Array<string>;
}
export interface LoginActionData {
  email: string;
  password: string;
  userID: number;
  handler: LoginActionHandler;
}

export enum LoginActionHandler {
  AUTO = "auto",
  MANUAL = "manual",
  RESET_PASSWORD = "reset_password",
}

export interface LoginActionResponse {
  handler: LoginActionHandler;
  status: number;
  colors: Array<string>;
  phoneTypes: Array<PhoneType>;
  standardViolations: Array<Violation>;
  userTenants: Array<Tenant>;
  user: User | null;
  email?: string;
}
